import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { SelectOption, SelectProps } from '@ui';
import { AdministrationPermissionTypes } from 'enums/onboarding/crm';

// components
import { FormSelect } from '@ui';

export interface IProps extends SelectProps {
  hideLimitedPermission?: boolean;
}

const AdministrationPermissionsSelect = ({
  hideLimitedPermission,
  ...rest
}: IProps) => {
  const { t } = useTranslation(['onboarding', 'form']);

  const options = useMemo<SelectOption[]>(() => {
    const options = hideLimitedPermission
      ? [
          AdministrationPermissionTypes.Admin,
          AdministrationPermissionTypes.None,
          AdministrationPermissionTypes.ReadOnly,
        ]
      : [
          AdministrationPermissionTypes.Admin,
          AdministrationPermissionTypes.None,
          AdministrationPermissionTypes.LimitedAdmin,
          AdministrationPermissionTypes.ReadOnly,
        ];

    return options.map((key) => ({
      id: key,
      label: t(`user_management.administration_permissions.${key}`),
    }));
  }, [t, hideLimitedPermission]);

  return <FormSelect {...rest} options={options} />;
};

export default AdministrationPermissionsSelect;
